import localforage from 'localforage';
import { isEmpty } from 'lodash';
import * as KEYS from '../../../config';

export const isLogged = ({ token }) => !isEmpty(token);

export const currentUser = ({ user }) => user;

export const currentClient = ({ client }) => client;

export const isOperadora = () => localforage.getItem(KEYS.userOperadoraStorageKey);

export const isBeneficiario = () => localforage.getItem(KEYS.userBeneficiarioStorageKey);

export const isDependente = () => localforage.getItem(KEYS.userDependenteStorageKey);

export const isOuvidoria = () => localforage.getItem(KEYS.userOuvidoriaStorageKey);

export const isAuditor = () => localforage.getItem(KEYS.userAuditorStorageKey);

export const isPrestador = () => localforage.getItem(KEYS.userPrestadorStorageKey);

export const isPrestadorAdministrativo = () => localforage.getItem(KEYS.userPrestadorAdministrativoStorageKey);

export const isAdmin = () => localforage.getItem(KEYS.userAdminStorageKey);

export const currentPermissions = () => localforage.getItem(KEYS.userPermissionsStorageKey);

export const currentUraBean = ({ uraBean }) => uraBean;
